<template>
  <div class="tip-bar d-flex align-items-center">
    <template v-if="tip.icon">
      <div
        class="tip-bar__icon d-flex align-items-center justify-content-center"
      >
        <i :class="tip.icon"></i>
      </div>
    </template>
    <template v-else>
      <div
        class="tip-bar__icon-content d-flex align-items-center justify-content-center"
        :class="tip.iconConfig?.type"
      >
        <i :class="tip.iconConfig?.icon" />
      </div>
    </template>
    <span class="tip-bar__title">
      {{ tip.title }}
    </span>
    <span
      v-if="tip.tip"
      class="tip-bar__link ms-3 d-flex align-items-center saiba-mais-integracao-potencial__ga"
      @click="activeLink"
    >
      <i class="icon-long-arrow-right" />
      {{ tip.tip }}
    </span>
    <i
      v-if="close"
      class="tip-bar__close icon-nave-close ms-auto me-4"
      @click="closeTip"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type ITipBar = {
  title: string;
  tip: string;
  icon: string;
  iconConfig?: { icon: string; type: string };
};

export default defineComponent({
  name: "TipBar",

  props: {
    tip: { type: Object as PropType<ITipBar>, required: true },
    close: { type: Boolean, default: false },
  },

  emits: ["activeLink", "close"],

  setup(props, context) {
    const activeLink = () => {
      context.emit("activeLink", true);
    };

    const closeTip = () => {
      context.emit("close");
    };

    return {
      activeLink,
      closeTip,
    };
  },
});
</script>

<style lang="scss" scoped>
.tip-bar {
  background: var(--insights-color-19);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  height: toRem(80px);
  width: 100%;

  &__icon {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    height: 100%;
    width: toRem(98px);

    > i {
      background-color: var(--insights-color-1);
      width: 100%;
      height: toRem(35px);
    }
  }

  &__icon-content {
    padding-left: toRem(22px);
    padding-right: toRem(13px);

    > i {
      font-size: toRem(30px);
    }
  }

  &__title {
    font-family: "text-medium";
    font-size: 22px;
    color: var(--insights-color-1);
  }

  &__link {
    font-family: "title-tertiary";
    cursor: pointer;
    color: var(--insights-color-22);
    gap: 10px;
    margin-top: toRem(3px);

    > i {
      background-color: var(--insights-color-22);
      height: toRem(15px);
      width: toRem(18px);
      margin-top: toRem(2px);
    }
  }

  &__close {
    background-color: #aca9a9;
    height: toRem(15px);
    width: toRem(15px);
    cursor: pointer;
  }

  .warning {
    > i {
      color: var(--insights-color-5);
    }
  }
}
</style>
